<template>
    <li
    v-if="report.length != 0"
    class="report-box">
        <div class="title">
            <h1>报告</h1>
			<el-link
			type="success "
			:underline="false"
			:href="dzurl"
			target="_blank">
			报告定制></el-link>
			<el-link
			type="warning "
			:underline="false"
			:href="zzurl"
			target="_blank">
			报告赞助></el-link>
            <el-link
            type="primary"
            :underline="false"
            :href="'/Index/wjs_search_res.html?kw=' + $route.query.name + '&cgy=bg'"
            target="_blank">
            更多></el-link>
        </div>

        <div class="con report">
            <a
            v-for="(i, index) of report.slice(0, 8)"
            :key="index"
            :href="i.body"
            target="_blank">
                <div class="zt-con">
                    <div class="zt-banner">
                        <img v-if="i.image" :src="'' + i.image">
                        <div v-else class="zt-banner-default">
                            <img :src="defaultImageSrc">
                            <span class="default-title">{{i.title}}</span>
                        </div>
                    </div>
                    <p>{{i.title}}</p>
                </div>
            </a>
        </div>
    </li>
</template>

<script>
export default {
    name: 'report',
    data() {
        return {
            report: [],
			dzurl: 'http://www.100ec.cn/Index/datareport.html',
			zzurl: 'http://www.100ec.cn/Index/sponsorship.html',
            defaultImageSrc: '/Public/home/images/wjs_bg.jpg',
          
        }
    },
    mounted() {
        axios.get('/Index/topic_json?p=1&name:"报告类"&title=' + this.$route.query.name)
        .then((res) => {
            if(res.data.list.length != 0) {
                res.data.list.forEach(item => {
                    if(item.cname == '报告类' ){
                        this.report.push(item)
                    }
                })
            }
        })
    }
}
</script>

<style scoped>
.zt-banner-default {
    position: relative;
    overflow: hidden;
}
.zt-banner-default img {
    width: 100%;
    /* height: 160px; */
    transition: all .3s ease;
}
.default-title {
    position: absolute;
    width: 80%;
    top: 23%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 19px;
    text-shadow: 2px 2px 4px #000000;
}
.report {
    display: flex;
    flex-wrap: wrap;
}
.report a {
    flex: 0 0 25%;
    margin-bottom: 20px;
}
.report a .zt-con {
    padding-right: 20px;
}
.report a:nth-child(4n+4) .zt-con {
    padding-right: 0;
}
.report a .zt-banner {
    overflow: hidden;
}
.report a .zt-banner img {
    width: 100%;
    height: 160px;
    transition: all .3s ease;
}
.report a p {
    height: 34px;
    font-size: 12px;
    color: #555;
    background: #eee;
    line-height: 18px;
    overflow: hidden;
    padding: 5px;
    transition: all .3s ease;
}
.report a:hover img {
    transform: scale(1.1);
}
.report a:hover p {
    color: #409eff;
}

@media(max-width: 868px) {
    .report {
        justify-content: space-between;
    }
    .report a {
        flex: 0 0 48%;
    }
    .report a .zt-con {
        padding-right: 0;
    }
    .report a .zt-banner img {
        height: 100%;
    }
}
</style>